// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var GoogleApis$SmartcutsMacros = require("../../bs-googleapis/apis/GoogleApis.bs.js");
var RegExUtils$SmartcutsMacros = require("../../bs-utils/src/RegExUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var GoogleApiHelpers$SmartcutsMacros = require("./GoogleApiHelpers.bs.js");
var GoogleSheetTypes$SmartcutsMacros = require("./GoogleSheetTypes.bs.js");
var GoogleApis__Sheets$SmartcutsMacros = require("../../bs-googleapis/apis/sheets/GoogleApis__Sheets.bs.js");
var GoogleApis__Sheets__Schema$SmartcutsMacros = require("../../bs-googleapis/apis/sheets/GoogleApis__Sheets__Schema.bs.js");

function loadClientButReloadExtensionIfGapiIsNotDefined(param) {
  if (GoogleApis$SmartcutsMacros.isGapiUndefined(undefined)) {
    return Util$SmartcutsMacros.wait(250).then(function (_timeoutId) {
                  return browser.runtime.reload();
                }).then(function (param) {
                return GoogleApis__Sheets$SmartcutsMacros.load(undefined);
              });
  } else {
    return GoogleApis__Sheets$SmartcutsMacros.load(undefined);
  }
}

function maybeGetSpreadsheetIdFromUrl(url) {
  var captures = OptionUtils$SmartcutsMacros.map(Caml_option.null_to_opt(RegExUtils$SmartcutsMacros.googleSheetsRe.exec(url)), (function (prim) {
          return prim;
        }));
  if (captures !== undefined && captures.length > 1) {
    return Caml_option.nullable_to_opt(Caml_array.get(captures, 1));
  }
  
}

function isGoogleSheetUrl(param) {
  return RegExUtils$SmartcutsMacros.googleSheetsRe.test(param);
}

function diffCells(expectPaste, _indexOpt, _diffsOpt, _row1, row2) {
  while(true) {
    var indexOpt = _indexOpt;
    var diffsOpt = _diffsOpt;
    var row1 = _row1;
    var index = indexOpt !== undefined ? indexOpt : 0;
    var diffs = diffsOpt !== undefined ? diffsOpt : [];
    var match = Belt_Array.get(row1.cells, index);
    var match$1 = Belt_Array.get(row2.cells, index);
    if (match !== undefined) {
      if (match$1 !== undefined) {
        var cellDiff = Curry._4(GoogleSheetTypes$SmartcutsMacros.Cell.WithPosition.compare, expectPaste, {
              colIndex: index,
              rowIndex: row1.rowIndex,
              value: match
            }, {
              colIndex: index,
              rowIndex: row2.rowIndex,
              value: match$1
            }, undefined);
        if (cellDiff !== undefined) {
          _row1 = GoogleSheetTypes$SmartcutsMacros.Row.applyCellDiff(cellDiff, row1);
          _diffsOpt = $$Array.append(diffs, [{
                  TAG: /* UpdateCell */0,
                  _0: cellDiff,
                  _1: row1
                }]);
          _indexOpt = index + 1 | 0;
          continue ;
        }
        _diffsOpt = diffs;
        _indexOpt = index + 1 | 0;
        continue ;
      }
      var cellDiff_rowIndex = row1.rowIndex;
      var cellDiff_diff = {
        TAG: /* Removed */2,
        _0: match
      };
      var cellDiff$1 = {
        rowIndex: cellDiff_rowIndex,
        colIndex: index,
        diff: cellDiff_diff
      };
      _row1 = GoogleSheetTypes$SmartcutsMacros.Row.applyCellDiff(cellDiff$1, row1);
      _diffsOpt = $$Array.append(diffs, [{
              TAG: /* UpdateCell */0,
              _0: cellDiff$1,
              _1: row1
            }]);
      _indexOpt = index + 1 | 0;
      continue ;
    }
    if (match$1 === undefined) {
      return diffs;
    }
    var tmp;
    var exit = 0;
    if (expectPaste !== undefined) {
      if (typeof match$1 === "number" || match$1.TAG !== /* Value */1) {
        exit = 1;
      } else {
        var text = match$1._0;
        var exit$1 = 0;
        switch (text.TAG | 0) {
          case /* StaticText */0 :
          case /* PasteText */1 :
              exit$1 = 2;
              break;
          default:
            exit = 1;
        }
        if (exit$1 === 2) {
          var text$1 = text._0;
          if (text$1 === expectPaste || text$1 === expectPaste + " ") {
            tmp = {
              TAG: /* Value */1,
              _0: {
                TAG: /* PasteText */1,
                _0: expectPaste
              }
            };
          } else {
            exit = 1;
          }
        }
        
      }
    } else {
      tmp = match$1;
    }
    if (exit === 1) {
      if (typeof match$1 === "number" || match$1.TAG !== /* Value */1) {
        tmp = match$1;
      } else {
        var text$2 = match$1._0;
        switch (text$2.TAG | 0) {
          case /* StaticText */0 :
          case /* PasteText */1 :
              tmp = {
                TAG: /* Value */1,
                _0: {
                  TAG: /* StaticText */0,
                  _0: text$2._0
                }
              };
              break;
          default:
            tmp = match$1;
        }
      }
    }
    var cellDiff_rowIndex$1 = row2.rowIndex;
    var cellDiff_diff$1 = {
      TAG: /* Added */1,
      _0: tmp
    };
    var cellDiff$2 = {
      rowIndex: cellDiff_rowIndex$1,
      colIndex: index,
      diff: cellDiff_diff$1
    };
    var diffs$1 = match$1 === /* Empty */0 ? diffs : Belt_Array.concat(diffs, [{
              TAG: /* UpdateCell */0,
              _0: cellDiff$2,
              _1: row1
            }]);
    _row1 = GoogleSheetTypes$SmartcutsMacros.Row.applyCellDiff(cellDiff$2, row1);
    _diffsOpt = diffs$1;
    _indexOpt = index + 1 | 0;
    continue ;
  };
}

function allCellsEmpty(row) {
  if (row !== undefined) {
    return Belt_Array.every(row.cells, (function (cell) {
                  return cell === 0;
                }));
  } else {
    return true;
  }
}

function compare(expectPaste, sheet1, sheet2) {
  if (sheet1.id !== sheet2.id) {
    Util$SmartcutsMacros.logAndRaiseJsError("Sheets don't have same id");
  } else if (Caml_obj.caml_notequal(sheet1.headers, sheet2.headers)) {
    Util$SmartcutsMacros.logAndRaiseJsError("Sheets don't have same columns");
  }
  var rows1 = sheet1.rows;
  var rows2 = sheet2.rows;
  var _indexOpt;
  var _diffsOpt;
  var _param;
  while(true) {
    var indexOpt = _indexOpt;
    var diffsOpt = _diffsOpt;
    var index = indexOpt !== undefined ? indexOpt : 0;
    var diffs = diffsOpt !== undefined ? diffsOpt : [];
    var match = Belt_Array.get(rows1, index);
    var match$1 = Belt_Array.get(rows2, index);
    if (match !== undefined && allCellsEmpty(match$1) && !allCellsEmpty(match)) {
      _param = undefined;
      _diffsOpt = Belt_Array.concat(diffs, [{
              TAG: /* DeleteRow */2,
              _0: match
            }]);
      _indexOpt = index + 1 | 0;
      continue ;
    }
    if (match$1 === undefined) {
      return diffs;
    }
    if (allCellsEmpty(match) && !allCellsEmpty(match$1)) {
      var newRow_rowIndex = match$1.rowIndex;
      var newRow_cells = Belt_Array.map(match$1.cells, (function (value) {
              if (typeof value === "number") {
                return value;
              }
              if (value.TAG !== /* Value */1) {
                return value;
              }
              var textContent = value._0;
              if (textContent.TAG !== /* StaticText */0) {
                return value;
              }
              var textContent$1 = textContent._0;
              if (OptionUtils$SmartcutsMacros.equalsSome(textContent$1, expectPaste)) {
                return {
                        TAG: /* Value */1,
                        _0: {
                          TAG: /* PasteText */1,
                          _0: textContent$1
                        }
                      };
              } else {
                return value;
              }
            }));
      var newRow = {
        rowIndex: newRow_rowIndex,
        cells: newRow_cells
      };
      _param = undefined;
      _diffsOpt = Belt_Array.concat(diffs, [{
              TAG: /* AppendRow */1,
              _0: newRow
            }]);
      _indexOpt = index + 1 | 0;
      continue ;
    }
    if (match === undefined) {
      return diffs;
    }
    var updates = diffCells(expectPaste, undefined, undefined, match, match$1);
    var match$2 = updates.length;
    if (match$2 !== 0) {
      _param = undefined;
      _diffsOpt = Belt_Array.concat(diffs, updates);
      _indexOpt = index + 1 | 0;
      continue ;
    }
    _param = undefined;
    _diffsOpt = diffs;
    _indexOpt = index + 1 | 0;
    continue ;
  };
}

function maybePadMissingCellsWithEmptyValues(cellDiffColIndex, cells) {
  if (cellDiffColIndex <= (cells.length - 1 | 0)) {
    return cells;
  }
  var missingCellCount = cellDiffColIndex - (cells.length - 1 | 0) | 0;
  var cellsForPadding = Caml_array.make(missingCellCount, /* Empty */0);
  return $$Array.append(cells, cellsForPadding);
}

function getGridLimitsFromErrorMessage(message) {
  var re = /Range \(.+\) exceeds grid limits. Max rows: (\d+), max columns: (\d+)/;
  var result = re.exec(message);
  var maybeMaxRows = result !== null ? Caml_option.nullable_to_opt(Caml_array.get(result, 1)) : undefined;
  var maybeMaxCols = result !== null ? Caml_option.nullable_to_opt(Caml_array.get(result, 2)) : undefined;
  var arg = OptionUtils$SmartcutsMacros.map(maybeMaxRows, Caml_format.caml_float_of_string);
  var arg$1 = OptionUtils$SmartcutsMacros.map(maybeMaxCols, Caml_format.caml_float_of_string);
  return {
          maxRows: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })(-1),
          maxCols: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
              })(-1)
        };
}

function getSpreadsheetSize_withEdgeCaseHandling(spreadsheetId, accessToken, maybeOnlyFirstNRows, client) {
  var wrappedGet = function (param, param$1) {
    return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi((function (accessToken, client) {
                  return GoogleApis__Sheets$SmartcutsMacros.get(accessToken, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, spreadsheetId, undefined, undefined, client);
                }), param, param$1);
  };
  return wrappedGet(accessToken, client).then(function (result) {
              var maybeSpreadsheet;
              if (result.TAG === /* Ok */0) {
                var maybeSpreadsheet$1 = result._0;
                if (typeof maybeSpreadsheet$1 === "number") {
                  return Util$SmartcutsMacros.logAndRaiseJsError("Could not reset invalid token");
                }
                maybeSpreadsheet = maybeSpreadsheet$1.TAG === /* MethodDidReturnUsingOriginalToken */0 ? maybeSpreadsheet$1._0 : maybeSpreadsheet$1.return_;
              } else {
                var match = result._0;
                switch (match.TAG | 0) {
                  case /* MethodDidThrowPromiseError */0 :
                      var httpResponse = match.errorType;
                      if (typeof httpResponse === "number") {
                        return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                      }
                      switch (httpResponse.TAG | 0) {
                        case /* GapiIsUndefined */2 :
                            return Util$SmartcutsMacros.logAndRaiseJsError("Gapi not loaded");
                        case /* HttpResponse */12 :
                            var httpResponse$1 = httpResponse._0;
                            console.warn("Google api call failed:", httpResponse$1);
                            return Util$SmartcutsMacros.logAndRaiseJsError("Google api call failed with http response " + String(httpResponse$1.result.error.code));
                        default:
                          return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                      }
                  case /* JsExnWhileRemoveCachedOAuthToken */1 :
                      return Util$SmartcutsMacros.logAndRaiseJsError("Error while removing cached token");
                  case /* PromiseErrorWhileGetNewOAuthToken */2 :
                      return Util$SmartcutsMacros.logAndRaiseJsError("Error while getting new token");
                  
                }
              }
              var func = GoogleApis__Sheets__Schema$SmartcutsMacros.Spreadsheet.getGridDataFor;
              var arg = Belt_Option.map(Belt_Option.flatMap(maybeSpreadsheet, (function (param) {
                          return Curry._3(func, param, 0, 0);
                        })), (function (param) {
                      return GoogleApis__Sheets__Schema$SmartcutsMacros.GridData.countRowsMinusHeaderRow(maybeOnlyFirstNRows, param);
                    }));
              return Promise.resolve((function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            })(0));
            });
}

var Schema;

exports.Schema = Schema;
exports.loadClientButReloadExtensionIfGapiIsNotDefined = loadClientButReloadExtensionIfGapiIsNotDefined;
exports.maybeGetSpreadsheetIdFromUrl = maybeGetSpreadsheetIdFromUrl;
exports.isGoogleSheetUrl = isGoogleSheetUrl;
exports.compare = compare;
exports.maybePadMissingCellsWithEmptyValues = maybePadMissingCellsWithEmptyValues;
exports.getGridLimitsFromErrorMessage = getGridLimitsFromErrorMessage;
exports.getSpreadsheetSize_withEdgeCaseHandling = getSpreadsheetSize_withEdgeCaseHandling;
/* Util-SmartcutsMacros Not a pure module */
